const handlers = {
    route: {
        from: {
            set: 'route_from_set'
        },
        to: {
            set: 'route_to_set'
        }
    }
};

const initVuexState = function(state) {
    state.route = {
        from: null,
        to: null
    };
};

const initGetters = function(getters) {
    getters.route = state => state.route;
};

const initActions = function(actions) {
    actions[handlers.route.from.set] = ({ commit }, fromRoute) => commit(handlers.route.from.set, fromRoute);
    actions[handlers.route.to.set] = ({ commit }, toRoute) => commit(handlers.route.to.set, toRoute);
};

const initMutations = function(mutations) {
    mutations[handlers.route.from.set] = (state, fromRoute) => (state.route.from = fromRoute);
    mutations[handlers.route.to.set] = (state, toRoute) => (state.route.to = toRoute);
};

const initAppState = function(appState, store) {
    appState.route = {
        from: {
            get: () => store.getters.route.from,
            set: fromRoute =>{
                if (fromRoute && fromRoute.name) store.dispatch(handlers.route.from.set, fromRoute);
            }
        },
        to: {
            get: () => store.getters.route.to,
            set: toRoute => {
                if (toRoute && toRoute.name) store.dispatch(handlers.route.to.set, toRoute);
            }
        }
    };
};

export default {
    initVuex(vuexState, getters, actions, mutations) {
        initVuexState(vuexState);
        initGetters(getters);
        initActions(actions);
        initMutations(mutations);
    },
    initAppState(appState, store) {
        initAppState(appState, store);
    }
};



// WEBPACK FOOTER //
// ./_common/data/route.js